import React, { Component } from 'react';

class IconTicketHistorySecond extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
                <path fill="#fff" fillRule="evenodd" d="M4.427 1.496a8.47 8.47 0 0110.7 1.054 8.483 8.483 0 01-2.75 13.832 8.468 8.468 0 01-9.234-1.839A8.482 8.482 0 014.427 1.496zm.785 12.927a7.057 7.057 0 008.916-.88 7.07 7.07 0 00-2.29-11.525A7.056 7.056 0 004.141 3.55a7.069 7.069 0 001.07 10.873zm3.424-12.03a.706.706 0 011.205.5v5.654a.707.707 0 01-.706.707H5.428a.706.706 0 010-1.414h3V2.893c0-.187.075-.367.208-.5z" clipRule="evenodd"></path>
            </svg>
        );
    }
}

export default IconTicketHistorySecond;